import React from 'react'
import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa'
import First_blog from '../Image/First_blog.jpg'
import blog1 from '../Image/blog1.jpg'
import blog2 from '../Image/blog2.jpg'
import blog3 from '../Image/blog3.jpg'
import blog4 from '../Image/blog4.jpg'
import { Helmet } from 'react-helmet-async'
function Blog_page() {
  const canonicalUrl = 'https://www.internselite.net/Blog'
  return (
    <div>
      <Helmet>
        <title>
          InternsElite Blog | Insights on Internships and Professional Courses
        </title>
        <meta
          name="description"
          content="Discover insightful articles on internships, professional courses, online training, and the best online courses. Stay updated with trends in Machine Learning, Digital Marketing, Web Development, and more at InternsElite."
        />
        <meta
          name="keywords"
          content="online internship, professional courses, certification course, online training, best online courses, online internship with certificate, virtual internship, remote internship, digital marketing internship, internship for college students, best IT courses, courses with placement, professional training"
        />
        <meta
          property="og:title"
          content="InternsElite Blog | Insights on Internships and Professional Courses"
        />
        <meta
          property="og:description"
          content="Discover insightful articles on internships, professional courses, online training, and the best online courses. Stay updated with trends in Machine Learning, Digital Marketing, Web Development, and more at InternsElite."
        />
        <meta property="og:url" content="https://internselite.net/Blog" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="InternsElite Blog | Insights on Internships and Professional Courses"
        />
        <meta
          name="twitter:description"
          content="Discover insightful articles on internships, professional courses, online training, and the best online courses. Stay updated with trends in Machine Learning, Digital Marketing, Web Development, and more at InternsElite."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="Blog_background_image d-sm-block d-md-none mt-5">
        <div className="container-fluid Blog_background_color pt-4">
          <div className="text-center blog_Main_text py-5">
            <h1 className="display-2 pt-4 text-white">Blog's</h1>
            <h3 className="text-white pt-2">
              Explore expert advice, exclusive internship opportunities, and the
              latest industry insights on the InternsElite blog. Whether you're
              passionate about AI, Machine Learning, Web Development, or Digital
              Marketing, we have the resources to propel your career forward.
              Discover the secrets to landing your dream internship, mastering
              cutting-edge technologies, and gaining a competitive edge in the
              job market. Join us on this exciting journey and unleash your full
              potential with InternsElite.
            </h3>
          </div>
        </div>
      </div>

      <div className="Blog_background_image mt-5 d-none d-md-block">
        <div className="container-fluid Blog_background_color py-5">
          <div className="text-start pt-5 blog_Main_text mt-2 px-5">
            <h1 className="display-2 text-white pt-5 mt-5">Blog's</h1>
            <h3 className="text-white pt-4 pb-5 mb-5">
              Explore expert advice, exclusive internship opportunities, and the
              latest industry insights on the InternsElite blog. Whether you're
              passionate about AI, Machine Learning, Web Development, or Digital
              Marketing, we have the resources to propel your career forward.
              Discover the secrets to landing your dream internship, mastering
              cutting-edge technologies, and gaining a competitive edge in the
              job market. Join us on this exciting journey and unleash your full
              potential with InternsElite.
            </h3>
          </div>
        </div>
      </div>
      <First_comp />
      <Blog_card />
    </div>
  )
}

function First_comp() {
  return (
    <div className="py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-6 latest_blog_comp">
            <h1 className="fs-1">Latest</h1>
            <div className="mt-3">
              <div className="text-center">
                <img src={First_blog}></img>
              </div>
            </div>
          </div>
          <div className="col-md-6 px-2 latest_blog_comp d-none d-md-block pt-4">
            <h2 className="mt-5">
              Advance Your Profession with InternsElite's Online Courses
            </h2>
            <p className="mt-4">
              The only way to keep up with the competition and advance in your
              job in today's lightning-fast digital environment is to commit to
              lifelong learning. Online courses from internsElite provide a
              convenient and adaptable alternative to acquire new skills for
              individuals in a variety of situations, including students,
              working professionals, and those seeking to change careers.
              InternsElite is a one-stop shop for high-quality online courses
              that cover a broad variety of subjects and professions.
            </p>
            <Link to="/best-online-courses-internselite">
              <button className="px-5 mt-3 py-2">Read More</button>
            </Link>
          </div>

          <div className="col-md-6 mobile_latest_blog_comp latest_blog_comp d-sm-block d-md-none">
            <h2 className="fs-3 mt-4 text-center">
              Advance Your Profession with InternsElite's Online Courses
            </h2>
            <p className="mt-3">
              The only way to keep up with the competition and advance in your
              job in today's lightning-fast digital environment is to commit to
              lifelong learning. Online courses from internsElite provide a
              convenient and adaptable alternative to acquire new skills for
              individuals in a variety of situations, including students,
              working professionals, and those seeking to change careers.
              InternsElite is a one-stop shop for high-quality online courses
              that cover a broad variety of subjects and professions.
            </p>
            <div className="text-center">
              <Link to="/best-online-courses-internselite">
                <button className="px-5 mt-3  py-2">Read More</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Blog_card() {
  const Card = [
    {
      title:
        'InternsElite Offers Online Internships to Help You Reach Your Full Potential',
      description:
        'Gaining practical experience is just as crucial as getting theoretical knowledge...',
      imageUrl: blog1,
      link: '/Online-Internship',
    },
    {
      title:
        'InternsElite  Can  Help You Advance Your Career  with IIT Courses',
      description:
        'The IITs, or Indian Institutes of Technology, are well-known for the excellent...',
      imageUrl: blog2,
      link: '/Courses-From-IIT',
    },
    {
      title:
        'InternsElite Offers Professional Courses to Help in Your Career',
      description:
        'Making a lasting impression is more crucial than ever in todays...',
      imageUrl: blog3,
      link: '/Elevate-Your-Career-With-Professional-Courses',
    },
    {
      title: 'The Ultimate Guide to Online Training',
      description:
        'Both students and working professionals in todays fast-paced environment rely heavily on online training programs...',
      imageUrl: blog4,
      link: '/The-Power-Of-Online-Training',
    },
  ]
  return (
    <div className="">
      {/* ----------------------------Mobile View--------------------------- */}
      <div className="container d-sm-block d-md-none latest_blog_comp mb-4">
        <h1 className="fs-2">New Blog's</h1>
        <div className="container px-3 pb-2">
          <div className="row">
            {Card.map((Card, index) => (
              <div className="col-12" key={index}>
                <Link className="Program_card_link" to={Card.link}>
                  <div className="border shadow Program_mobile_card">
                    <div>
                      <img
                        className="p-2"
                        src={Card.imageUrl}
                        alt={Card.title}
                      />
                    </div>
                    <div className="px-4">
                      <h1 className="text-center pt-2">{Card.title}</h1>
                      <p className="pt-1">{Card.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ----------------------------Desktop View--------------------------- */}
      <div className="container pt-5 d-none d-xl-block">
        <div className="Container">
          <div className="Container latest_blog_comp">
            <h1 className="fs-1">New Blog's</h1>
          </div>
        </div>
        <div className="container pb-5">
          <div className="row">
            {Card.map((Card, index) => (
              <div className="col-md-3" key={index}>
                <Link className="Program_card_link" to={Card.link}>
                  <div className="border shadow Program_card">
                    <div>
                      <img
                        className="p-2"
                        src={Card.imageUrl}
                        alt={Card.title}
                      />
                    </div>
                    <div className="px-4">
                      <h1 className="text-center pt-2">{Card.title}</h1>
                      <p className="pt-1">{Card.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ------------------Tab View-------------------- */}
      <div className="container pt-5 d-none d-md-block d-xl-none">
        <div className="Container">
          <div className="Container latest_blog_comp">
            <h1 className="fs-1">New Blog's</h1>
          </div>
        </div>
        <div className="container pb-5">
          <div className="row">
            {Card.map((Card, index) => (
              <div className="col-md-4" key={index}>
                <Link className="Program_card_link" to={Card.link}>
                  <div className="border shadow tab_Program_card">
                    <div>
                      <img
                        className="p-2"
                        src={Card.imageUrl}
                        alt={Card.title}
                      />
                    </div>
                    <div className="px-4">
                      <h1 className="text-center pt-2">{Card.title}</h1>
                      <p className="pt-1">{Card.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blog_page
